import { Dispatch } from 'redux'
import { Logger } from 'DVWebNodeUtils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import {
  triggerPurchasingTransition,
  resetPurchasingTransition,
  failedPurchasingDueToClientDependency
} from '../actionBox'
import { startPurchase, PurchaseError } from '../../integrations/purchase'
import { refreshMainActionBox, refreshBtfActionBoxes, refreshEpisode } from '../wps'
import { safeBoolean } from '../../utils/utils'

export type RefreshAfterPurchase = {
  pageTitleId: string,
  offerAsin: string,
  canonicalTitleId?: string,
  isSeasonPurchase: boolean
}
export const refreshAfterPurchaseActionDispatcher = ({ pageTitleId, offerAsin, canonicalTitleId, isSeasonPurchase }: RefreshAfterPurchase) => {
  const promises = []
  promises.push(refreshMainActionBox(pageTitleId, false, offerAsin, canonicalTitleId ))
  if (safeBoolean(isSeasonPurchase)) {
    promises.push(refreshBtfActionBoxes(pageTitleId))
  } else if (canonicalTitleId) {
    promises.push(refreshEpisode(canonicalTitleId))
  }
  return Promise.all(promises);
}

export const triggerAuiPurchase = (dispatch: Dispatch) => async (
  logger: Logger,
  pageTitleId: string,
  canonicalTitleId: string | undefined,
  tvodAction: WpsRuntime.atv.wps.PurchaseActionProps,
  refTag: string,
  dataAttrs: object
) => {
  const { asin: offerAsin, purchaseData, csrfToken, offerToken } = tvodAction
  const purchasingTransitionArgs = {
    canonicalTitleId,
    offerAsin,
    isSeasonPurchase: purchaseData.isSeasonPurchase,
    purchasingText: purchaseData.text || '',
    errorHeader: purchaseData.modalText || '',
  }

  const purchaseOptions = {
    ...purchaseData,
    ...dataAttrs,
    asin: offerAsin,
    pinVerification: { csrfToken },
    purchaseArgs: {
      refTag,
      offerToken,
      csrfToken,
      asin: offerAsin
    }
  }

  const refreshAfterPurchaseArgs = {
    canonicalTitleId,
    pageTitleId,
    offerAsin,
    isSeasonPurchase: purchaseData.isSeasonPurchase,
  }

  dispatch(triggerPurchasingTransition(purchasingTransitionArgs))
  startPurchase({ logger, options: purchaseOptions })
    .then(args => {
      if (args && args.reload === false) {
        dispatch(
          resetPurchasingTransition({
            offerAsin,
            canonicalTitleId
          })
        )
      } else {
        refreshAfterPurchaseActionDispatcher(refreshAfterPurchaseArgs)
      }
    })
    .catch(err => {
      logger.error(err)
      if (err && err.reason === PurchaseError.AUI_DEPENDENCY) {
        dispatch(
          failedPurchasingDueToClientDependency({
            offerAsin,
            canonicalTitleId
          })
        )
      }
    })
}
